import React, { Fragment } from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { tiposTelefone } from '../../constants/telefones.constants'

class Telefones extends React.Component {
  state = {
    invalid: false,
  }

  onChangeNumero = (e) => {
    let { value } = e.target
    const { index, telefone, tipoTelefone } = this.props
    telefone.numero = this.mphone(value)
    telefone.tipoTelefone = tipoTelefone || tiposTelefone.PESSOAL
    this.props.onChange(index, telefone)
    const invalid =
      !(telefone.numero.length === 0) && !(telefone.numero.length === 14) && !(telefone.numero.length === 13)
    this.setState({ invalid })
  }

  onChangeNomeContato = (e) => {
    const { index, telefone } = this.props
    telefone.nomeContato = e.target.value
    this.props.onChange(index, telefone)
  }

  onPrincipalClick = () => {
    const { index, telefone, onChange, disabled } = this.props
    if (disabled) return
    onChange(index, { ...telefone, principal: true })
  }

  onWhatsappClick = () => {
    const { index, telefone, onChange, disabled } = this.props
    if (disabled) return
    const isWa = telefone.tipoTelefone === tiposTelefone.WHATSAPP
    const nextTipo = isWa ? tiposTelefone.PESSOAL : tiposTelefone.WHATSAPP
    onChange(index, { ...telefone, tipoTelefone: nextTipo })
  }

  mphone = (v) => {
    v = v.replace(/\D/g, '')
    v = v.replace(/^(\d{2})(\d)/g, '($1)$2')
    v = v.replace(/(\d)(\d{4})$/, '$1-$2')
    return v
  }

  render() {
    const { choosePrincipal, required, telefone, checkWhatsapp, disabled, showContactName, inline } = this.props
    const showOpcoes = choosePrincipal || checkWhatsapp
    const showNomeContato = showContactName && telefone && !telefone.principal
    if (inline && !showOpcoes && !showNomeContato) {
      return (
        <Form.Group className={required ? 'required' : ''}>
          <Form.Label htmlFor="paciente-telefone-trabalho-numero">Telefone</Form.Label>
          <Form.Control
            id="paciente-telefone-trabalho-numero"
            className={this.state.invalid ? 'is-invalid' : ''}
            name="numero"
            type="text"
            value={telefone.numero}
            onChange={this.onChangeNumero}
            disabled={disabled}
            required={required}
            maxLength={14}
            placeholder="(00) 00000-0000"
          />
          <div className="invalid-feedback">Telefone inválido.</div>
        </Form.Group>
      )
    }

    return (
      <Row className="form-row align-items-start">
        <Form.Group
          as={Col}
          xs={12}
          sm={showOpcoes ? 7 : 12}
          lg={showOpcoes ? 5 : 12}
          className={`${required ? 'required' : ''} mb-2 mb-sm-0`}
        >
          <Form.Label htmlFor="numero" className="small mb-1 font-weight-normal text-muted">
            Telefone
          </Form.Label>
          <Form.Control
            className={this.state.invalid ? 'is-invalid' : ''}
            name="numero"
            type="text"
            value={telefone.numero}
            onChange={this.onChangeNumero}
            disabled={disabled}
            required={required}
            maxLength={14}
            placeholder="(00) 00000-0000"
          />
          <div className="invalid-feedback">Telefone inválido.</div>
        </Form.Group>

        {showOpcoes && (
        <Col xs={12} sm={5} lg={4} className="d-flex flex-column justify-content-end pb-0 mb-2 mb-sm-0">
          <Form.Label className="d-none d-sm-block small text-muted mb-1">Opções rápidas</Form.Label>
          <div className="d-flex flex-wrap align-items-center telefone-opcoes-btns">
            {choosePrincipal && (
              <Button
                type="button"
                variant={telefone.principal ? 'primary' : 'outline-primary'}
                size="sm"
                disabled={disabled}
                className="rounded-pill px-2 shadow-sm mr-2 mb-1"
                onClick={this.onPrincipalClick}
              >
                Principal
              </Button>
            )}
            {checkWhatsapp && (
              <Button
                type="button"
                variant={telefone.tipoTelefone === tiposTelefone.WHATSAPP ? 'success' : 'outline-success'}
                size="sm"
                disabled={disabled}
                className="rounded-pill px-2 shadow-sm mb-1"
                onClick={this.onWhatsappClick}
              >
                WhatsApp
              </Button>
            )}
          </div>
        </Col>
        )}

        {showContactName && !telefone.principal && (
          <Form.Group as={Col} xs={12} lg={3} className={`${required ? 'required' : ''} mb-0`}>
            <Fragment>
              <Form.Label htmlFor="numeroContato" className="small mb-1 font-weight-normal text-muted">
                Nome do contato
              </Form.Label>
              <Form.Control
                name="nomeContato"
                value={telefone.nomeContato}
                onChange={this.onChangeNomeContato}
                disabled={disabled}
                required={required}
                maxLength={100}
              />
            </Fragment>
          </Form.Group>
        )}
      </Row>
    )
  }
}

export default Telefones
